import { useDebounce } from '@shared/hooks'

import { useFiltersContext } from '@/context'
import { JobQueries } from '@/graphql/queries/job.queries'
import { JobsFilterParams, JobsReponse } from '@/types/Job'
import { getJobsFilterParams } from '@/util/FiltersUtil'

import { useGraphql } from '../useGraphql'

const useJobs = () => {
  const [{ jobsFilters, marketSegmentFilter, searchString }] = useFiltersContext()

  const debouncedSearch = useDebounce(searchString, 1000)

  const filterParams: Partial<JobsFilterParams> = {
    ...getJobsFilterParams(jobsFilters),
    search: debouncedSearch || undefined,
    marketSegmentIds: marketSegmentFilter.marketSegmentIds,
  }
  return useGraphql<{ jobs: JobsReponse[] }>(JobQueries.QUERY_KEYS.getJobsList, JobQueries.getJobsList(), {
    filter: filterParams,
  })
}

export default useJobs
